import { useLocation, useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  Col,
  Empty,
  Grid,
  Row,
  Skeleton,
  Tag,
  Typography,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import {
  getEntity,
  getSearcherByEntityId,
  getSearcherByIdEntity,
} from "../../../controllers/entities";
import "./Entities.scss";
import { UserOutlined } from "@ant-design/icons";
import { capitalizeString, getCityNameByCode } from "../../../shared/util";
import Moment from "react-moment";
import RecomendationList from "../../components/Recomedations";
import {
  Contact,
  DataItem,
  PageSetting,
  RecordStatus,
  RequestStatus,
  routerData,
} from "../..";
import useRecomendations from "../../../hooks/recomendations-entities-hook";
import { useSelector } from "react-redux";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { getSended } from "../../../controllers/store/actions/connection/connection-sended-actions";
import { RequestConnection } from "../../../models/RequestConnection";
import ConnectionRequest from "../../components/Forms/Modal/ConnectionRequest/Connection-Request";
import store from "../../../controllers/store";

type NotificationType = "success" | "info" | "warning" | "error";

const { Paragraph } = Typography;
const dispatch = store.dispatch;
const { useBreakpoint } = Grid;
const EntityDetail = () => {
  const screens = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const { params, entity: etype } = location.state;
  const [page, setPage] = useState(1);
  const [groups, setGroups] = useState([]);
  const [entity, setEntity] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [searchersLoading, setSearchersLoading] = useState(false);
  const [searchers, setSearchers] = useState([]);
  const { result, getRecomendations } = useRecomendations();
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState<Contact>();
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: "UNAB",
      description: "Solicitud enviada correctamente.",
    });
  };

  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  const group_detail = (group: any, entity: any) => {
    let params = {
      id: group.groups_id.id,
      name: group.groups_id.NME_GRUPO_GR,
      type: group.groups_id.actor_type.actor,
    };

    navigate(`/groups/${params.id}`, { state: { params, entity } });
  };

  const university_detail = (university: any, entity: any) => {
    let params = {
      id: university.id,
      name: university.nombre,
      type: university.actor_type.actor,
    };
    navigate(`/searchers/${params.id}`, { state: { params, entity } });
  };

  useEffect(() => {
    const getentity = async () => {
      setLoading(true);
      const entitie = await getEntity(params?.id, etype);
      setEntity(entitie);
      setLoading(false);
    };
    getRecomendations("all", { filter: "" }, 1, 5);
    getentity();
  }, []);

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <ConnectionRequest
        open={isModalOpen}
        onOk={(value: any, text: string) => {
          const request = new RequestConnection(
            "",
            text,
            user.me,
            {
              name: contact?.name || "",
              email: contact?.email || "",
              organization_name:
                contact?.organization_name || contact?.name || "",
              type: contact?.type || "",
            },
            RequestStatus.Pending,
            value.requestType || "",
            contact?.type
          );

          saveRequest(request);
          sendNotification(request);
          setIsModalOpen(false);
          openNotificationWithIcon("success");
          dispatch(
            getSended(
              "connection_request",
              {
                meta: "filter_count",
                filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
              },
              1,
              10
            )
          );
        }}
        onCancel={() => setIsModalOpen(false)}
        contact={{
          name: contact?.name || "",
          email: contact?.email || "",
          organization_name: contact?.organization_name || "",
          type: contact?.type || "",
        }}
      />
      <Skeleton loading={loading} active className="full-width">
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={24} lg={16}>
            {etype === "commons" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Nombre</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.social_reason ||
                            entity.institution_name ||
                            entity?.nombre ||
                            entity.NOMBRE
                        )}
                      </p>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">Descripción</h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.description ||
                            entity.DESCRIPCION ||
                            "Sin descripcion"
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">
                        Especialidad del conocimiento
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity.ESPECIALIDAD_DE_CONOCIMIENTO || ""
                        )}
                      </p>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Area de conocimiento</h2>
                      <p className="conection-value">
                        {capitalizeString(entity?.AREA_DE_CONOCIMIENTO || "")}
                      </p>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">
                        Gran área de conocimiento
                      </h2>
                      <p className="conection-value">
                        {capitalizeString(
                          entity?.GRAN_AREA_DE_CONOCIMIENTO || ""
                        )}
                      </p>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">
                        Actividad económica principal
                      </h2>
                      {entity?.ACTIVIDAD_ECONOMICA?.map((c: any) => {
                        return (
                          <div>
                            <Tag
                              color="blue"
                              style={{ marginBottom: 10 }}
                              bordered={false}
                            >
                              {capitalizeString(
                                c.comercial_activity_id.description || ""
                              )}
                            </Tag>{" "}
                            <br />
                          </div>
                        );
                      })}
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <h2 className="conection-label">
                        Actividades económicas secundarias
                      </h2>
                      {entity?.ACTIVIDAD_ECONOMICA?.map((c: any) => {
                        return (
                          <div>
                            <Tag
                              color="blue"
                              style={{ marginBottom: 10 }}
                              bordered={false}
                            >
                              {capitalizeString(
                                c.comercial_activity_id.description || ""
                              )}
                            </Tag>{" "}
                            <br />
                          </div>
                        );
                      })}
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Ciudad</h2>
                      <p className="conection-value">
                        {capitalizeString(entity?.CIUDAD || "sin definir")}
                      </p>
                    </Col>
                    {entity.features ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Características</h2>
                        <p className="conection-value">
                          {capitalizeString(entity?.features || "sin definir")}
                        </p>
                      </Col>
                    ) : null}
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Última Actualización</h2>
                      <p className="conection-value">
                        <Moment format="DD/MM/YYYY">
                          {entity?.update_date}
                        </Moment>
                      </p>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">
                        Reconociento Minciencias (Sí/No){" "}
                      </h2>
                      <p className="conection-value">
                        {entity?.recognized_min === "1" ? "Si" : "No"}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {entity.url ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">URL</h2>
                        {entity?.url ? (
                          <Button
                            type="primary"
                            onClick={() => {
                              window.open(entity?.url, "_blank");
                            }}
                          >
                            Abrir URL
                          </Button>
                        ) : (
                          "Sin url"
                        )}
                      </Col>
                    ) : null}
                  </Row>
                </Card>
                <>
                  <h1 className="conection-heading-section">Investigadores</h1>
                  <Skeleton
                    loading={searchersLoading}
                    active
                    className="full-width"
                  >
                    <Card
                      className="ant-card-conection ant-card-conection-border"
                      onClick={() => {}}
                      hoverable
                      style={{ width: "100%", marginBottom: 30 }}
                    >
                      <Row gutter={[8, 8]} style={{ width: "100%" }}>
                        {searchers.map((s: any) => (
                          <Col span={12} key={s.id}>
                            <li
                              onClick={() =>
                                navigate(`/searchers/${s.id}`, {
                                  state: { param: s, entityType: "searchers" },
                                })
                              }
                              style={{ marginBottom: 20 }}
                              className="flex with-pointer"
                            >
                              <Avatar icon={<UserOutlined />} />
                              <p className="profile-info">
                                {`${s?.nombre}` || ""}
                                <span>{`${s?.nme_niv_form_pr}` || ""}</span>
                              </p>
                            </li>
                          </Col>
                        ))}
                      </Row>
                    </Card>
                  </Skeleton>
                </>
              </div>
            ) : null}
            {etype === "entities" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection ant-card-conection-border"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Nombre</h2>
                      <p className="conection-value">
                        {(
                          entity.social_reason ||
                          entity.institution_name ||
                          entity?.nombre ||
                          ""
                        ).toUpperCase()}
                      </p>
                    </Col>
                    {entity?.description ? (
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        style={{ width: "100%", marginBottom: 20 }}
                      >
                        <h2 className="conection-label">Descripción</h2>
                        <p className="conection-value">
                          {capitalizeString(
                            entity.description || "Sin descripcion"
                          )}
                        </p>
                      </Col>
                    ) : null}
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">NIT</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.nit)}
                      </p>
                    </Col>
                  </Row>
                  <Row
                    gutter={[8, 8]}
                    style={{ width: "100%", marginBottom: 20 }}
                  >
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      style={{ width: "100%", marginBottom: 20 }}
                    >
                      <h2 className="conection-label">
                        Actividades económicas
                      </h2>
                      {entity?.ciiu?.map((c: any, index: number) => {
                        if (index === 0) {
                          return (
                            <div>
                              {screens.lg ? (
                                <Tag
                                  color="success"
                                  style={{ marginBottom: 10 }}
                                  bordered={false}
                                >
                                  {c.comercial_activity_id?.description || ""}
                                </Tag>
                              ) : null}
                              <p>
                                <Tag color="green">PRINCIPAL</Tag>
                                {c.comercial_activity_id?.description || ""}
                              </p>
                            </div>
                          );
                        } else {
                          return (
                            <div>
                              {screens.lg ? (
                                <Tag
                                  color="blue"
                                  style={{ marginBottom: 10 }}
                                  bordered={false}
                                >
                                  {c.comercial_activity_id?.description || ""}
                                </Tag>
                              ) : null}
                              <p>
                                <Tag color="blue">SECUNDARIA</Tag>
                                {c.comercial_activity_id?.description || ""}
                              </p>
                            </div>
                          );
                        }
                      })}
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Departamento</h2>
                      <p className="conection-value">
                        {getCityNameByCode(entity?.city)?.departamento ||
                          entity.stateRaw ||
                          ""}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Ciudad</h2>
                      <p className="conection-value">
                        {getCityNameByCode(entity?.city)?.municipio ||
                          entity.cityRaw ||
                          ""}
                      </p>
                    </Col>
                    {entity.features ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Características</h2>
                        <p className="conection-value">
                          {capitalizeString(entity?.features || "sin definir")}
                        </p>
                      </Col>
                    ) : null}
                    {entity?.issue_date ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Fecha de expedición</h2>
                        <p className="conection-value">
                          {entity?.issue_date || "N/A"}
                        </p>
                      </Col>
                    ) : null}
                    {entity?.current_date ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Vigencia</h2>
                        <p className="conection-value">
                          {entity?.current_date || "N/A"}
                        </p>
                      </Col>
                    ) : null}
                    {entity?.update_date ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">
                          Última Actualización
                        </h2>
                        <p className="conection-value">
                          {entity?.update_date || "N/A"}
                        </p>
                      </Col>
                    ) : null}
                    {entity.source ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Fuente</h2>
                        <p className="conection-value">{entity?.source}</p>
                      </Col>
                    ) : null}
                  </Row>
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    {entity.url ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">URL</h2>
                        {entity?.url ? (
                          <Button
                            type="primary"
                            onClick={() => {
                              window.open(entity?.url, "_blank");
                            }}
                          >
                            Abrir URL
                          </Button>
                        ) : (
                          "Sin url"
                        )}
                      </Col>
                    ) : null}
                  </Row>
                </Card>
                <>
                  <h1 className="conection-heading-section">Investigadores</h1>
                  <Card
                    className="ant-card-conection ant-card-conection-border"
                    onClick={() => {}}
                    hoverable
                    style={{ width: "100%", marginBottom: 30 }}
                  >
                    <Row gutter={[8, 8]} className="full-width">
                      <Col xs={24} sm={12} md={8} lg={24}>
                        {!entity?.searchers ||
                        entity?.searchers?.length === 0 ? (
                          <Empty description={"0 Registros"} />
                        ) : null}
                      </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                      {entity?.searchers?.map((s: any) => (
                        <Col lg={12} key={s.id}>
                          <div
                            onClick={() => {
                              go(
                                {
                                  id: s.searchers_id.id,
                                  name: s.searchers_id.nombre,
                                  type: s.searchers_id.actor_type.actor,
                                },
                                "searchers"
                              );
                            }}
                            style={{ marginBottom: 20 }}
                            className="flex with-pointer"
                          >
                            <Avatar icon={<UserOutlined />} />
                            <p className="profile-info">
                              {`${s?.searchers_id?.nombre}` || ""}
                              <span>
                                {`${s?.searchers_id?.nme_niv_form_pr}` || ""}
                              </span>
                            </p>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <Row />
                  </Card>
                </>
                {searchers.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">
                      Investigadores
                    </h1>
                    <Skeleton
                      loading={searchersLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-border"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {searchers.map((s: any) => (
                            <Col span={12} key={s.id}>
                              <li>
                                <li
                                  onClick={() => {
                                    go(
                                      {
                                        id: s.searchers_id.id,
                                        name: s.searchers_id.nombre,
                                        type: s.searchers_id.actor_type.actor,
                                      },
                                      "searchers"
                                    );
                                  }}
                                  style={{ marginBottom: 20 }}
                                  className="flex with-pointer"
                                >
                                  <Avatar icon={<UserOutlined />} />
                                  <p className="profile-info">
                                    {`${s?.searchers_id?.nombre}` || ""}
                                    <span>
                                      {`${s?.searchers_id?.nme_niv_form_pr}` ||
                                        ""}
                                    </span>
                                  </p>
                                </li>
                              </li>
                            </Col>
                          ))}
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
              </div>
            ) : null}
            {etype === "universities" ? (
              <div>
                <h1 className="conection-heading-section">Datos generales</h1>
                <Card
                  className="ant-card-conection"
                  onClick={() => {}}
                  hoverable
                  style={{ width: "100%", marginBottom: 30 }}
                >
                  <Row gutter={[8, 8]} style={{ width: "100%" }}>
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Nombre</h2>
                      <p className="conection-value">
                        {capitalizeString(entity.institution_name)}
                      </p>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">Descripción</h2>
                      <p className="conection-value text-justify">
                        {capitalizeString(entity.description || "No definino")}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Departamento</h2>
                      <p className="conection-value">
                        {getCityNameByCode(entity?.city)?.departamento ||
                          entity.stateRaw ||
                          ""}
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={12}>
                      <h2 className="conection-label">Ciudad</h2>
                      <p className="conection-value">
                        {getCityNameByCode(entity?.city)?.municipio ||
                          entity.cityRaw ||
                          ""}
                      </p>
                    </Col>
                    {entity.is_accredited ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">
                          Institución acreditada?
                        </h2>
                        <p className="conection-value">
                          {entity.is_accredited === 1 ? "Si" : "No"}
                        </p>
                      </Col>
                    ) : null}

                    {entity.recognized_min ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">
                          Reconociento Minciencias
                        </h2>
                        <p className="conection-value">
                          {capitalizeString(
                            entity.recognized_min ? "Si" : "No"
                          )}
                        </p>
                      </Col>
                    ) : null}

                    {entity?.issue_date ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Fecha de expedición</h2>
                        <p className="conection-value">
                          {entity?.issue_date || "N/A"}
                        </p>
                      </Col>
                    ) : null}

                    {entity?.current_date ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Vigencia</h2>
                        <p className="conection-value">
                          {entity?.current_date || "N/A"}
                        </p>
                      </Col>
                    ) : null}

                    {entity?.update_date ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">
                          Última Actualización
                        </h2>
                        <p className="conection-value">
                          {entity?.update_date || "N/A"}
                        </p>
                      </Col>
                    ) : null}

                    {entity?.source ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Fuente</h2>
                        <p className="conection-value">{entity?.source}</p>
                      </Col>
                    ) : null}
                    {entity.features ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">Características</h2>
                        <p className="conection-value">
                          {capitalizeString(entity?.features || "sin definir")}
                        </p>
                      </Col>
                    ) : null}
                    {entity.url ? (
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <h2 className="conection-label">URL</h2>
                        {entity?.url ? (
                          <Button
                            type="primary"
                            onClick={() => {
                              window.open(entity?.url, "_blank");
                            }}
                          >
                            Abrir URL
                          </Button>
                        ) : (
                          "Sin url"
                        )}
                      </Col>
                    ) : null}
                  </Row>
                </Card>
                {groups.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">Grupos</h1>
                    <Skeleton
                      loading={groupsLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-border"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]} style={{ width: "100%" }}>
                          {groups.map((g: any) => {
                            return (
                              <Col xs={24} sm={24} md={24} lg={12}>
                                <Button
                                  size="middle"
                                  onClick={() => {
                                    group_detail(g, "groups");
                                  }}
                                  style={{
                                    marginBottom: 10,
                                    marginRight: 20,
                                    width: "auto",
                                  }}
                                >
                                  <Paragraph
                                    style={{ marginBottom: "0px" }}
                                    ellipsis={{
                                      rows: 1,
                                      expandable: true,
                                      symbol: "Más",
                                      tooltip: (
                                        g.groups_id.NME_GRUPO_GR || ""
                                      ).toLowerCase(),
                                    }}
                                  >
                                    {capitalizeString(g.groups_id.NME_GRUPO_GR)}
                                  </Paragraph>
                                </Button>
                              </Col>
                            );
                          })}
                        </Row>
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
                {searchers.length > 0 ? (
                  <>
                    <h1 className="conection-heading-section">
                      Investigadores
                    </h1>

                    <Skeleton
                      loading={groupsLoading}
                      active
                      className="full-width"
                    >
                      <Card
                        className="ant-card-conection ant-card-conection-border"
                        onClick={() => {}}
                        hoverable
                        style={{ width: "100%", marginBottom: 30 }}
                      >
                        <Row gutter={[8, 8]}>
                          {searchers.map((s: any) => (
                            <Col lg={12} key={s.id}>
                              <div
                                onClick={() =>
                                  university_detail(s, "searchers")
                                }
                                style={{ marginBottom: 20 }}
                                className="flex with-pointer"
                              >
                                <Avatar icon={<UserOutlined />} />
                                <p className="profile-info">
                                  {`${s?.nombre}` || ""}
                                  <span>{`${s?.nme_niv_form_pr}` || ""}</span>
                                </p>
                              </div>
                            </Col>
                          ))}
                        </Row>
                        <Row />
                      </Card>
                    </Skeleton>
                  </>
                ) : null}
              </div>
            ) : null}
            {etype === "searchers" ? (
              <div>
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2>Nombre</h2>
                    {capitalizeString(entity?.nombre || "sin definir")}
                  </Col>
                  <Col xs={24} sm={12} md={24} lg={12}>
                    <h2>Familia de institución</h2>
                    {capitalizeString(entity.inst_filia || "sin definir")}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2>Nivel de formación</h2>
                    <p>
                      <strong>
                        {capitalizeString(entity?.nme_niv_form_pr)}
                      </strong>{" "}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2>Gran área de conocimiento</h2>
                    <p>
                      {capitalizeString(
                        entity?.nme_gran_area_pr || "sin definir"
                      )}
                    </p>
                  </Col>
                </Row>

                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2>Área de conocimiento</h2>
                    <p>{entity?.nme_area_pr || ""}</p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2>Espacialidad del conocimiento</h2>
                    <p>
                      {capitalizeString(
                        entity?.nme_esp_area_pr || "sin definir"
                      )}
                    </p>
                  </Col>
                </Row>
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  {entity?.update_date ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2 className="conection-label">última actualización</h2>
                      <p className="conection-value">
                        {entity?.update_date || "sin definir"}
                      </p>
                    </Col>
                  ) : null}
                  {entity?.source ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2>Fuente</h2>
                      <p>{capitalizeString(entity?.source || "sin definir")}</p>
                    </Col>
                  ) : null}
                  {entity.recognize_min ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2>Reconociento Minciencias (Sí/No) </h2>
                      <p>{entity?.recognized_min === "1" ? "Si" : "No"}</p>
                    </Col>
                  ) : null}
                  {entity.features ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2>Características |</h2>
                      <p>
                        {capitalizeString(entity?.features || "sin definir")}
                      </p>
                    </Col>
                  ) : null}
                </Row>
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  {entity.enlace_cvlac ? (
                    <Col xs={24} sm={24} md={24} lg={12}>
                      <h2>URL</h2>
                      {entity?.enlace_cvlac ? (
                        <Button
                          type="primary"
                          onClick={() => {
                            window.open(entity?.enlace_cvlac, "_blank");
                          }}
                        >
                          Abrir CVLAC
                        </Button>
                      ) : (
                        "Sin url"
                      )}
                    </Col>
                  ) : null}
                </Row>
              </div>
            ) : null}
          </Col>
          {user?.me ? (
            <Col xs={24} sm={24} md={24} lg={8}>
              <h1 className="conection-heading-section">Sugerencias</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Skeleton
                  loading={result.loading}
                  active
                  className="full-width"
                >
                  <RecomendationList
                    totalPages={result.pagination?.total}
                    onPaginationChanged={(page) => {
                      getRecomendations(
                        "all",
                        { filter: {} },
                        page,
                        PageSetting.limit
                      );
                      setPage(page);
                    }}
                    onConnect={(contact) => {
                      setContact({
                        name: contact.title,
                        type: contact?.description || "",
                        email: contact.contact_email,
                      });
                      setIsModalOpen(!isModalOpen);
                    }}
                    data={result.values
                      .filter((r) => r.id !== params?.id)
                      .map((recomendation: any) => {
                        console.log("recomendations", recomendation);
                        return {
                          title: recomendation.name,
                          description: `${recomendation.type?.actor} - ${
                            recomendation.city || recomendation.cityRaw
                          }`,
                          avatar: "",
                          contact_email: recomendation.contact_email,
                        } as DataItem;
                      })}
                  />
                </Skeleton>
              </Card>
            </Col>
          ) : null}
        </Row>
      </Skeleton>
    </div>
  );
};

export default EntityDetail;
